'use client';

import React from 'react';
import { PortalAuthProvider } from '@/contexts/PortalAuthContext';

export default function PortalRootLayout({ children }: { children: React.ReactNode }) {
  return (
    <PortalAuthProvider>
      {children}
    </PortalAuthProvider>
  );
}
